import React, { useEffect, useRef, useState } from "react";
import maintenance from "../../../../../assets/image/category/maintenance.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import plugswire from "../../../../../assets/image/services/plugswire.webp";
import airfilter from "../../../../../assets/image/services/airfilter.webp";
import maintenance4 from "../../../../../assets/image/services/maintenance4.webp";
import coolentcheck from "../../../../../assets/image/services/coolentcheck.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";

export default function Maintenance() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <div className="overflow-hidden  ">
      {/* Maintenance Services*/}

      <div className="text-black md:w-full mx-auto">
        {/* Image Column (5/12 on large) */}
        <div className="flex flex-col w-full relative ">
          <img
            className=" lg:h-[30rem] md:h-[25rem] h-[20rem] md:w-full  w-full object-cover "
            src={maintenance}
            alt="maintenance"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/70 to-transparent"></div>
          <div className="absolute inset-0 mb-12 flex items-center justify-center text-white text-cente ">
            <h3
              className={`text-white text-center font-bold absolute lg:text-6xl md:text-4xl text-2xl mb-4  
           transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
            >
              Expert Vehicle Maintenance VAP
            </h3>
          </div>
          <div
            className={`absolute inset-0 lg:mt-14 md:mt-10 mt-12   flex items-center justify-center text-white text-center 
            transition-all duration-[900ms] delay-1000 ease-in-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              <MyButton
                text=" Maintenance Services"
                className="bg-orange-500 text-white py-[12px] rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12 on large) */}
        <div className="lg:col-span-7 md:col-span-1 lg:px-[8.5rem] md:px-[2.9rem]  text-center mx-2 py-7 ">
          <div className="">
            <p className="mb-3 text-[1.3rem]  text-gray-700 lg:font-normal">
              Is your vehicle due for routine maintenance? Notice any unusual
              performance? Most major repairs start as small, unnoticed issues.
              Regular maintenance catches problems early, keeping your car
              reliable and saving you thousands in unexpected breakdowns.
            </p>

            <p className="mb-3 text-[1.3rem]  text-gray-700 lg:block md:block hidden lg:font-normal">
              Our expert mechanics at Vancouver Auto Parts use high-quality
              automotive parts to keep your vehicle performing at its best.
            </p>
            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out mt-3
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-white bg-orange-500 cursor-pointer flex items-center">
                  Book a Same-Day Service Appointment
                  <FaArrowRight className="ml-2" />
                </button> */}

                <MyButton
                  text="Book  Same-Day  Appointment"
                  className="mx-auto  transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]">
        <div className="lg:py-[30px] px-2 container ">
          <h1 className="text-blue-900 font-bold text-[1.8rem] md:text-[2.3rem] lg:text-[2.9rem]  mb-3 text-center">
            Professional Car Care and Maintenance Services
          </h1>
          <p className="mb-3 lg:font-normal text-[1.38rem]  lg:px-[8%] md:px-[1%]  text-center">
            When regular maintenance is skipped, it affects overall performance
            and reliability. Our skilled technicians provide comprehensive
            inspections to assess the condition of critical auto parts,
            including brakes, suspension, filters, belts. Our proactive approach
            helps prevent costly repairs .
          </p>

          <div className="flex justtify-center items-center lg:px-[5.4%] py-[1.3rem]  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={coolentcheck}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Don’t Delay{" "}
                      <span className="text-[#2772AD]">Maintenance </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    Skipping routine maintenance may save time now, but small
                    issues quickly grow into costly repairs. From worn belts to
                    fluid leaks, our trained technicians catch early signs of
                    trouble before they cause major damage. Staying ahead with
                    regular service keeps your vehicle reliable, safe, and
                    running at peak efficiency.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[4%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem]  text-3xl   ">
                    <b>
                      Built with Better{" "}
                      <span className="text-[#2772AD]">Parts</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Using quality parts isn’t just about longevity—it’s about
                    keeping your engine running at its best. We rely on
                    high-grade automotive parts to ensure every system works
                    seamlessly. Paired with proper service intervals, these
                    components help prevent breakdowns, boost reliability, and
                    keep your ride smooth mile after mile.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={plugswire}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={maintenance4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl  ">
                    <b>
                      Don’t Skip{" "}
                      <span className="text-[#2772AD]">Inspections</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Delaying routine inspections might seem harmless, but it
                    often leads to costly repairs down the line. Skipping key
                    checkpoints allows minor wear to go unnoticed—until it
                    becomes a major failure. Proactive maintenance catches
                    problems early, preserves system performance, and keeps your
                    vehicle running safely and efficiently for longer.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
